import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { environment } from '@environment';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';

@Component({
  selector: 'app-cej-v2-allocation',
  templateUrl: './cej-v2-allocation.component.html',
  styleUrls: ['./cej-v2-allocation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2AllocationComponent {
  imgSrc = `${environment.wizbiiImages}/cejv2/benefit-from-it.jpg`;
}

@NgModule({
  imports: [CommonModule, ImaginarySrcModule],
  declarations: [CejV2AllocationComponent],
  exports: [CejV2AllocationComponent],
})
export class CejV2AllocationModule {}
